import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useLanguage } from "../../contexts/LanguageContext";
import villasMeta from "../../data/villasMeta";
import { getVillaHeroImage } from "../../data/villaHeroImages";
import { buildOpenGraphMetadata } from "../../utils/openGraph";
import OpenGraph from "./OpenGraph";

function SiteOpenGraph() {
  const { pathname } = useLocation();
  const { language } = useLanguage();

  const metadata = useMemo(() => {
    const slugMatch = pathname.match(/^\/villa\/([^/]+)/);
    const slug = slugMatch?.[1];
    const villa = slug ? villasMeta.find((item) => item.slug === slug) : null;
    const villaImageUrl = slug ? getVillaHeroImage(slug) : null;

    return buildOpenGraphMetadata(pathname, villa, villaImageUrl, language);
  }, [pathname, language]);

  return <OpenGraph metadata={metadata} />;
}

export default SiteOpenGraph;
